import React from "react";
import { ISystemConfig, IDatabases, IDataCenter } from "../../vm";
import {
  IStackTokens,
  ITag,
  Stack,
  PrimaryButton,
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode,
  IColumn,
  TooltipHost,
  DefaultButton,
  Fabric,
  IDetailsListProps,
  IDetailsRowStyles,
  DetailsRow,
  Callout,
  DirectionalHint,
} from "office-ui-fabric-react";
import CustomDrawer from "../common/CustomDrawer";
import { getAllDataCenters } from "../../services/datacenter/DatacenterService";
import { ToastContext } from "../common/ToastProvider";
import Icon from "@mdi/react";
import {
  mdiTrashCanOutline,
  mdiPencilOutline,
  mdiEyeOutline,
  mdiDotsVertical,
} from "@mdi/js";
import { THEME, BRAND_SECONDARY } from "../../utils/Styles";
import NoDataTile from "../common/NoDataTile";
import ManageDatabaseDialogEdit from "./ManageDatabaseDialogEdit";
import { Loading } from "../../services/Loading";
import { ConfirmDialogContext } from "../common/ConfirmDialogProvider";
import { updateSystemConfig } from "../../services/system-config/SystemConfigService";
import { childrenGap, childrenGap8 } from "../common/Constants";

export interface ManageDatabaseDialogTable {
  data?: ISystemConfig;
  // handleLoading: any;
  handleDialogClose: any;
  handleDatabaseTableClose: any;
}

const ManageDatabaseDialogTable: React.FC<ManageDatabaseDialogTable> = ({
  data,
  // handleLoading,
  handleDialogClose,
  handleDatabaseTableClose,
}) => {
  //state
  const [state, setState] = React.useState({
    databases: [],
    isLoading: false,
    allDataCenter: [],
    dataCenterList: [],
    isOnEdit: false,
    selectedDatacenters: [],
    databaseObj: {
      name: "",
      datacenterId: "",
      datacenterName: "",
      isOpen: true,
      tables: [],
    },
    floorDict: {},
    manageDatabaseDialogEdit: {
      isOpen: false,
      index: undefined,
      data: undefined,
    },
    manageActionsCallout: {
      isOpen: false,
      index: undefined,
      element: undefined,
      data: undefined,
    },
  } as {
    databases: IDatabases[];
    isLoading: boolean;
    allDataCenter: IDataCenter[];
    isOnEdit: boolean;
    dataCenterList: ITag[];
    selectedDatacenters: ITag[];
    // databaseObj: {
    //   name: string;
    //   datacenterId: string;
    //   datacenterName: string;
    //   isOpen?: boolean;
    //   tables: {
    //     // name: string;
    //     floorId: string;
    //     floorName: string;
    //     dedicatedName: string;
    //     rackwiseName: string;
    //     // type: string;
    //   }[];
    // };
    databaseObj: IDatabases;
    floorDict: any;
    manageDatabaseDialogEdit: {
      isOpen: boolean;
      index?: number;
      data?: IDatabases;
    };
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      index?: number;
      data?: IDatabases;
    };
  });

  // customs hooks
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);

  const wrapStackTokens: IStackTokens = { childrenGap: 16 };

  const addUpdateValue = (data?: ISystemConfig) => {
    handleDialogClose(data);
  };

  // hooks
  React.useEffect(() => {
    const asyncFunc = async () => {
      await getDataCenters();
    };
    asyncFunc();

    console.log("state", state);
  }, []);

  const getDataCenters = async () => {
    setState({ ...state, isLoading: true });
    let result = await getAllDataCenters();
    if (result?.success) {
      let dataCenterList: ITag[] = [];
      let floorDict: any = {};

      result.data.forEach((item) => {
        dataCenterList.push({
          key: item._id as string,
          name: item.name,
        });
      });

      console.log("datacenters", result.data);

      floorDict = result.data.reduce((acc: any, item) => {
        let key: any = item._id;
        if (!acc[key]) {
          acc[key] = [];
        }
        item.floors.forEach((floor) => {
          let buildingName =
            item.buildings.find((building) => building._id === floor.buildingId)
              ?.name || "";
          acc[key].push({
            value: floor._id,
            label: buildingName + " - " + floor.name,
          });
        });
        return acc;
      }, {});
      console.log(floorDict);

      // let item = result.data.find((i) => {
      //   dataCenterList.forEach((e) => e.key === i._id);
      // });
      // item?.floors.forEach((floor) => {
      //   let ele = item?.buildings.find((building) => building._id === floor.buildingId);
      //   let floorArray = [{ value: floor._id, label: ele.name + " - " + floor.name }]
      //   floorDict = floorArray.reduce( function(acc, obj) {
      //     let key = item?._id
      //     if (!acc[key]) {

      //     }
      //   }, {})
      // })
      // let reqDataCenter = item?.buildings.find((i) => {
      //   item?.floors.forEach((e) => e.buildingId === i._id);
      // });

      let databases: any[] = [];
      if (data?.databases) {
        databases = data.databases.map((ele) => {
          return {
            ...ele,
            datacenterName:
              dataCenterList.find((e) => e.key === ele.datacenterId)?.name ||
              "",
            tables: ele.tables.map((e: any) => {
              e.floorName = getFloorName(
                ele.datacenterId,
                e.floorId,
                floorDict
              );
              return e;
            }),
          };
        });
      }
      setState({
        ...state,
        dataCenterList,
        allDataCenter: result.data,
        databases: databases,
        floorDict: floorDict,
        isLoading: false,
      });
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result?.message || "Error while getting Datacenter list",
        "error"
      );
      // setState({
      //   ...state,
      //   isLoading: false,
      // });
    }
  };

  const handleLoading = () => {
    setState({
      ...state,
      isLoading: !state.isLoading,
    });
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return (
          <span
            onClick={(ele) => handleCallOutOpenClose(true, ele, index, item)}
          >
            <Icon
              path={mdiDotsVertical}
              size={0.9}
              className="pointer"
              color={BRAND_SECONDARY}
            />
          </span>
          // <Stack horizontal>
          //   <TooltipHost
          //     content={"View Database Config"}
          //     id={`viewDatabaseConfig`}
          //     calloutProps={{
          //       gapSpace: 0,
          //     }}
          //     styles={{
          //       root: {
          //         display: "inline-block",
          //       },
          //     }}
          //   >
          //     <span
          //       onClick={() => handleEditDatabaseDialogOpen(true, false, index)}
          //     >
          //       <Icon
          //         path={mdiEyeOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.neutralPrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          //   &nbsp;&nbsp;
          //   <TooltipHost
          //     content={"Edit Database Config"}
          //     id={`editDatabaseConfig`}
          //     calloutProps={{
          //       gapSpace: 0,
          //     }}
          //     styles={{
          //       root: {
          //         display: "inline-block",
          //       },
          //     }}
          //   >
          //     <span
          //       onClick={() => handleEditDatabaseDialogOpen(true, true, index)}
          //     >
          //       <Icon
          //         path={mdiPencilOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.neutralPrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          //   &nbsp;&nbsp;
          //   <TooltipHost
          //     content={"Delete Database Config"}
          //     id={`deleteDatabaseConfig`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={() => deleteADatabase(item, index)}>
          //       <Icon
          //         path={mdiTrashCanOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.neutralPrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          // </Stack>
        );
      case "datacenterName":
        return (
          <span style={{ fontWeight: 600 }}>
            {item[column.fieldName as any]}
          </span>
        );
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  const handleEditDatabaseDialogOpen = (
    isOpen: boolean,
    isOnEdit: boolean,
    index?: number
  ) => {
    let databases = undefined;
    if (index !== undefined) {
      databases = { ...state.databases[index] };
    }
    setState({
      ...state,
      isOnEdit: isOnEdit,
      manageDatabaseDialogEdit: {
        isOpen: true,
        index,
        data: databases,
      },
    });
  };

  const handleEditDatabaseDialogClose = async (data: IDatabases) => {
    let databases = [...state.databases];
    if (data) {
      if (state.manageDatabaseDialogEdit.index !== undefined) {
        databases[state.manageDatabaseDialogEdit.index] = data;
        showToast("Database configuration updated successfully", "success");
      } else {
        databases.unshift(data);
        showToast("Database configuration added successfully", "success");
      }
    }
    setState({
      ...state,
      isOnEdit: false,
      manageDatabaseDialogEdit: {
        isOpen: false,
        index: undefined,
        data: undefined,
      },
      databases,
    });
  };

  const deleteADatabase = (item: IDatabases, index: number) => {
    showConfirmDialog(
      "Are You Sure",
      "Do you want to delete database configuration",
      async () => {
        setState({
          ...state,
          isLoading: true,
          manageActionsCallout: {
            isOpen: false,
            index: undefined,
            element: undefined,
            data: undefined,
          },
        });
        let databases = [...state.databases];
        let systemConfig: ISystemConfig = { ...(data as ISystemConfig) };

        databases.splice(index, 1);
        systemConfig["databases"] = databases;
        let result = await updateSystemConfig(systemConfig);
        if (result?.success) {
          addUpdateValue(result.data);
          setState({
            ...state,
            databases,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
          showToast("Database configuration deleted successfully", "success");
        } else {
          setState({
            ...state,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
          showToast(
            result.message || "Error while deleting database configuration",
            "error"
          );
        }
      }
    );
  };

  const getFloorName = (
    datacenterId: string,
    floorId: string,
    floorDict?: any
  ) => {
    let floorName = "";
    let dictionaryObj = floorDict ? floorDict : { ...state.floorDict };
    if (dictionaryObj[datacenterId]) {
      let floor = dictionaryObj[datacenterId].find(
        (ele: any) => ele.value === floorId
      );
      if (floor) {
        floorName = floor.label;
      }
    }
    return floorName;
  };

  // const onSaveDatabaseConfig = async () => {
  //   let result;
  //   let systemConfig: any = { ...data };

  //   systemConfig["databases"] = [...state.databases];
  //   handleLoading();
  //   console.log("syscon", systemConfig);

  //   result = await updateSystemConfig(systemConfig);
  //   handleLoading();
  //   if (result?.success) {
  //     // closeAddDialog(result.data);
  //     showToast("System Config for Databases updated successfully", "success");
  //   } else {
  //     showToast(
  //       result.message || "Error while updating System Config for Databases",
  //       "error"
  //     );
  //   }
  // };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    index?: number,
    data?: IDatabases
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        index,
        data,
      },
    });
  };

  return (
    <React.Fragment>
      <CustomDrawer
        title="View Databases Configuration"
        handelOpen={true}
        onClose={() => handleDatabaseTableClose()}
      >
        {state.isLoading && <Loading />}
        <Stack className="" tokens={childrenGap}>
          <Stack.Item align="end">
            <PrimaryButton
              text="Add Databases"
              onClick={() => handleEditDatabaseDialogOpen(true, false)}
              className="borderless-btn bg-white"
            />
          </Stack.Item>
          <Stack.Item>
            <div>
              {state.databases && state.databases.length > 0 ? (
                <Stack>
                  <Stack.Item>
                    <Fabric>
                      <DetailsList
                        items={state.databases}
                        columns={[
                          {
                            key: "datacenterName",
                            name: "Datacenter Name",
                            fieldName: "datacenterName",
                            minWidth: 100,
                            maxWidth: 150,
                            isResizable: true,
                          },
                          {
                            key: "name",
                            name: "Database Name",
                            fieldName: "name",
                            minWidth: 200,
                            maxWidth: 300,
                            isResizable: true,
                          },
                          {
                            key: "actions",
                            name: "Actions",
                            fieldName: "actions",
                            minWidth: 80,
                            maxWidth: 100,
                            isResizable: true,
                          },
                        ]}
                        compact={true}
                        setKey="set"
                        onRenderItemColumn={_renderItemColumn as any}
                        layoutMode={DetailsListLayoutMode.justified}
                        selectionMode={SelectionMode.none}
                        onRenderRow={_onRenderRow}
                      />
                    </Fabric>
                  </Stack.Item>
                </Stack>
              ) : (
                <NoDataTile title="No Databases Found"></NoDataTile>
              )}
            </div>
          </Stack.Item>
          {data && (
            <Stack.Item>
              <Stack
                horizontal
                horizontalAlign="end"
                wrap
                tokens={wrapStackTokens}
                className="pt-16"
              >
                <DefaultButton
                  text="Cancel"
                  onClick={() => handleDatabaseTableClose()}
                  className="borderless-btn"
                />
                {/* <PrimaryButton
                  text="Save"
                  onClick={() => onSaveDatabaseConfig()}
                /> */}
              </Stack>
            </Stack.Item>
          )}
        </Stack>
        {state.manageActionsCallout.isOpen && (
          <Callout
            styles={{ root: { width: 95, padding: 20 } }}
            role="alertdialog"
            ariaLabelledBy={
              state.manageActionsCallout &&
              state.manageActionsCallout.data?.datacenterId
            }
            gapSpace={0}
            target={state.manageActionsCallout.element}
            directionalHint={DirectionalHint.leftCenter}
            onDismiss={() => handleCallOutOpenClose(false)}
            // setInitialFocus={true}
          >
            <Stack tokens={childrenGap8}>
              <Stack.Item className="pointer">
                <span
                  onClick={() => {
                    handleEditDatabaseDialogOpen(
                      true,
                      false,
                      state.manageActionsCallout.index
                    );
                  }}
                  className="callout-options"
                >
                  View
                </span>
              </Stack.Item>
              <Stack.Item className="pointer">
                <span
                  onClick={() => {
                    handleEditDatabaseDialogOpen(
                      true,
                      true,
                      state.manageActionsCallout.index
                    );
                  }}
                  className="callout-options"
                >
                  Edit
                </span>
              </Stack.Item>
              <Stack.Item className="pointer">
                <span
                  onClick={() => {
                    deleteADatabase(
                      state.manageActionsCallout.data as IDatabases,
                      state.manageActionsCallout.index as number
                    );
                  }}
                  className="callout-options"
                >
                  Delete
                </span>
              </Stack.Item>
            </Stack>
          </Callout>
        )}
        {state.manageDatabaseDialogEdit.isOpen && (
          <ManageDatabaseDialogEdit
            systemConfig={data as ISystemConfig}
            databases={state.databases}
            dataCenterList={state.dataCenterList}
            allDataCenter={state.allDataCenter}
            data={state.manageDatabaseDialogEdit.data}
            index={state.manageDatabaseDialogEdit.index as number}
            isOnEdit={state.isOnEdit}
            handleLoading={handleLoading}
            handleEditDialogClose={(data: IDatabases) => {
              handleEditDatabaseDialogClose(data);
            }}
            handleDialogClose={handleDialogClose}
          />
        )}
      </CustomDrawer>
    </React.Fragment>
  );
};

export default ManageDatabaseDialogTable;
